import React from 'react'
import './Header.css';

const Header = () => {
  return(
    <div className="banner-container">
    <div className="banner">
      {/* <span className="icon"> ⓘ  </span>
      <span className="text">We're committed to HIPAA regulations</span> */}
     <p className='text'>ⓘ We adhere to HIPAA guidelines with dedication.</p>  


    </div>
  </div>
  );
};
export default Header;





